import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee } from '../../../network/employee';
import PayrollCostCenterList from './PayrollCostCenterList';
import {
  addSalaryStructureAssignment,
  getSalaryStructureAssignmentDetails,
  updateSalaryStructureAssignment,
} from '../../../network/salaryStructureAssignment';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBillTransfer } from 'react-icons/fa6';
const AddSalaryStructureAssignHr = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [dataSource, setDataSource] = useState([{}]);
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddEmployeeAdvance } = useMutation({
    mutationKey: ['addEmployeeAdvance'],
    mutationFn: (body) =>
      edit
        ? updateSalaryStructureAssignment(body, id)
        : addSalaryStructureAssignment(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getSalaryStructureAssignment],
      });
      form.resetFields();
      navigate('/salary-structure-assign-hr');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: salaryStructureHrDetails = {}, isLoading } = useQuery({
    queryKey: [queryKeys.getSalaryStructureAssignment, id],
    queryFn: () => getSalaryStructureAssignmentDetails(id),
    enabled: !!edit,
  });
  const { data: employee } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  const { data: salaryStructure } = useQuery({
    queryKey: [queryKeys.getSearchSalaryStructure],
    queryFn: () => getSearchApi('Salary Structure'),
    keepPreviousData: true,
  });
  const { data: payrollPayableAccount } = useQuery({
    queryKey: [queryKeys.getSearchpayrollPayableAccount],
    queryFn: () => getSearchApi('Account'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    // const totalPercentage = dataSource?.reduce(
    //   (total, item) => total + item?.percentage,
    // ) || 0;
    // if (totalPercentage !== 100) {
    //   message.error('Total percentage should be 100%');
    //   return false;
    // }
    setLoadingAdd(true);
    onAddEmployeeAdvance({
      ...values,
      company: companyName,
      currency: 'SAR',
      from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
      payroll_cost_centers: dataSource?.map((item) => ({ ...item })),
      repay_unclaimed_amount_from_salary:
        values?.repay_unclaimed_amount_from_salary ? 1 : 0,
    });
  };
  useEffect(() => {
    if (edit && salaryStructureHrDetails) {
      setDataSource(
        salaryStructureHrDetails?.data?.payroll_cost_centers?.length
          ? salaryStructureHrDetails?.data?.payroll_cost_centers
          : [{}]
      );
      form.setFieldsValue({
        ...salaryStructureHrDetails?.data,
        from_date: dayjs(salaryStructureHrDetails?.data?.from_date),
      });
    }
  }, [edit, salaryStructureHrDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={
          edit ? t.UpdateSalaryStructureAssign : t.AddSalaryStructureAssign
        }
        path="/salary-structure-assign-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.SalaryStructureAssign}
        subTitle={
          edit ? t.UpdateSalaryStructureAssign : t.AddSalaryStructureAssign
        }
        icon={<FaMoneyBillTransfer />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-salary-structure"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        form.setFieldsValue({
                          employee_name: option?.option?.employee_name,
                          department: option?.option?.department,
                          designation: option?.option?.designation,
                        });
                      }}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employee?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="designation" label={t.designation}>
                    <Input placeholder={t.designation} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="salary_structure"
                    label={t.SalaryStructure}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.SalaryStructure}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={salaryStructure?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payroll_payable_account"
                    label={t.payrollPayableAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.payrollPayableAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={payrollPayableAccount?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="from_date"
                    label={t.fromDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.fromDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="base" label={t.base}>
                    <Input type="number" placeholder={t.base} min={0} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="variable" label={t.variable}>
                    <Input type="number" placeholder={t.variable} min={0} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <PayrollCostCenterList
                    form={form}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    t={t}
                  />
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddSalaryStructureAssignHr;
